import React, { Fragment } from 'react';
import Box from '@mui/material/Box';
import ConfirmModalContainer from '../common/confirmModal/ConfirmModalContainer';
import styles from '../../../custom/style.module.css';
import reportStyles from '../flights/tabs/flightreport/reports.module.css';
import logStyle from './log.module.css';
import {
  Checkbox,
  Divider,
  FormControl, FormLabel, Grid, InputAdornment, MenuItem, Popover, Radio, RadioGroup, Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import {
  CustomDatePicker, CustomInputLabel, CustomRadio, CustomSelect, SelectInputProps, StyledCard, StyledCardTitle, InputProps, CustomButton, CustomTextField, FlexDiv,
  StyledDataGrid,
  DataGridProps,
  TableBadge,
} from '../../../custom/components';
import {
  DateFormat,
  MonthFormat,
  StickyNoteIcon
} from 'custom/constants';
import dayjs from 'dayjs';
import cookies from 'utils/cookies';
import DocModalContainer from '../common/docModal/DocModalContainer';
import moment from 'moment';
import AddNotes from '../common/addnotes';
import { AttachFile } from '@mui/icons-material';
import ReOpenModal from '../common/ReOpenModal';
import { grey } from '@mui/material/colors';
import { dateTimeTolocale } from 'utils/converter';

const Logs = (props) => {
  const {
    search, airlines, onChangeSearch, onChange, onSubmitLogs,
    onChangeFilter, remark, refROBrn,
    handleContractType,
    airlineId, allChecked, handleBulkCheck,
    handleRowCheck,
    handleClosePopup,
    checkedRows,
    filteredRows,
    filterLogs,
  } = props;

  const logCol = [
    {
      field: 'checkbox',
      headerName: '',
      width: 50,
      disabbledMenu: true,
      sortable: false,
      filterable: false,
      headerAlign: 'center',
      align: 'center',
      disableColumnMenu: true,
      cellClassName: logStyle.fixedFirst,
      headerClassName: logStyle.fixedFirstHead,
      renderHeader: () => (
        filterLogs != 'All' ? (
          <Checkbox
            checked={allChecked}
            onChange={handleBulkCheck}
            size='small'
            sx={{ marginLeft: '-10px' }}
          />
        ) : null
      ),
      renderCell: ({ row }) => {
        let noData = false;
        let noContractNames = props.contractNames.length === 0;
        
        if (row.data.every(item => item.value === '' || item.value === null) || row.data.length === 0) {
          if(props.contractNames && props.contractNames.every(item => item.name.includes(' | Auto'))) {
            noData = false;
          }
          else noData = true;
        }
        return (
          <Checkbox
            checked={row.checked}
            onChange={handleRowCheck(row)}
            size='small'
            disabled={(row.status === 'Finalized' || row.status === 'Pending' || row.status === 'Approved') 
              && props.filterLogs !== 'Finalized' || noData || noContractNames
            }
          />
        );
      },
    },
    {
      field: 'date',
      headerName: (props.search?.type === 'DAY' ? 'Daily ' : 'Monthly ') + 'Service Logs',
      width: 160,
      cellClassName: logStyle.fixedSecond,
      headerClassName: logStyle.fixedSecondHead,
      renderCell: ({ row }) => {
        return <div> {search.type === 'MONTH' ? moment(row.date).format('MMMM').toUpperCase() : moment(row.date).format(DateFormat).toUpperCase()}
          {row.status && <span className={`${logStyle.statusTag} ${styles.ml1}`}>
            {row.status && ((row.status === 'Pending' || row.status === 'Approved') ? 'Finalized': row.status )}</span>}
        </div>;
      }
    },
    ...(props.contractNames ? props.contractNames.map((columnName) => ({
      field: columnName?.name,
      headerName: columnName?.name,
      flex: 1,
      minWidth: 160,
      headerClassName: logStyle.colEllipse,
      headerAlign: 'left',
      align: 'left',
      renderCell: ({ row }) => (
        <CustomTextField
          type='text'
          size='small'
          disabled={columnName?.name?.includes(' | Auto') || row.status === 'Finalized'}
          value={row?.data?.find(item => item.label === columnName?.name)?.value ?
            row?.data?.find(item => item.label === columnName?.name)?.value :
            columnName?.name?.includes(' | Auto') ? '1' : ''
          }
          onChange={(e) => {
            const value = e.target.value;
            if (/^\d*\.?\d*$/.test(value)) {
              props.handleInputChange(row, columnName?.name, e.target.value);
            }
          }}
          onBlur={() => props.handleBlur(row)}
          className={`${styles.borderedIpTextfield} ${logStyle.inputLogWrapper}`}
          InputProps={{
            classes: {
              root: `${logStyle.inputLogRoot} ${styles.borderedIpRoot}`,
              input: `${logStyle.inputLogInput} ${styles.borderedIp}`,
              disabled: logStyle.inputLogDisabled,
              notchedOutline: styles.notchedOutline,
              error: styles.errorInput,
            },
            startAdornment: (
              <InputAdornment position='start' >
                {!columnName?.name?.includes(' | Auto') ? (() => {
                  const userObj = row?.data?.find(item => item.label === columnName?.name);
                  const user = userObj?.user;
                  const date = userObj?.date;
                  return (
                    <Tooltip title={
                      <>
                        <div>
                          Entered By: {user ? (`${user?.first_name} ${user?.last_name} | ${date ? dateTimeTolocale(date, 'DDMMMYY HH:mm').toUpperCase() : '-'}`) : ''}
                        </div>
                        <div>Role: {user?.role || '-'}</div>
                      </>
                    }>
                      <code className={styles.infoIcon}> i </code>
                    </Tooltip>
                  );
                })() : (
                  <Typography color={grey[600]} variant='caption'>Auto</Typography>
                )}
              </InputAdornment>
            ),

            endAdornment: (
              <InputAdornment position='end' className={logStyle.inputAdornedEnd}>
                <TableBadge badgeContent={row?.notes?.filter(note => note.cont_rowId === columnName.contractRowId).length} color='error' classes={{ badge: logStyle.badge }}>
                  <StickyNoteIcon title='Add/View Note'
                    // className={(typeof (row.id) !== 'number') || row.data.length === 0 || !props.disabledCheckbox?.includes(row?.id) ? styles.disabledImg : ''} 
                    onClick={(e) => props.handleOpenPopup('notes', e.currentTarget, {
                      row,
                      contractRowId: columnName.contractRowId,
                      type: 'notes',
                    })}
                  />
                </TableBadge>
              </InputAdornment>
            ),
            inputProps: {
              inputMode: 'decimal',
              pattern: '[0-9]*[.]?[0-9]*'
            }
          }}
        />
      )
    })) : []),

    {
      field: 'by',
      headerName: 'Submitted By',
      flex: 0.8,
      minWidth: 150,
      headerAlign: 'left',
      align: 'left',
      cellClassName: `${logStyle.fixedSecondLast} ${styles.cellTextWrap}`,
      headerClassName: logStyle.fixedSecondLastHead,
      renderCell: ({ row }) => {
        let logs = row.log && row.log[row.log.length - 1];
        return <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} useFlexGap className={styles.w100}>
          <span>{row.log && row.log.length > 0 ? `${logs?.user?.role} | ${logs?.user?.first_name}  ${logs?.user?.last_name} ` : '-'}</span>
          <TableBadge badgeContent={row.log?.length || 0} color='error' classes={{ badge: logStyle.badge }}>
            <StickyNoteIcon title='Add/View Note' onClick={(e) => props.handleOpenPopup('notes', e.currentTarget, {
              row,
              type: 'remarks',
            })} />
          </TableBadge>
        </Stack>;
      }
    },
    {
      field: 'action',
      headerName: 'Action',
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      minWidth: 100,
      sortable: false,
      disableColumnMenu: true,
      cellClassName: logStyle.fixedLast,
      headerClassName: logStyle.fixedLastHead,
      renderCell: ({ row }) => {
        return (
          <>
            <div className={styles.pointer}
              onClick={() => props.handleDoc(row)}>
              <Tooltip title='Add/View Attachment'>
                <TableBadge color='error' badgeContent={row?.docs?.length}>
                  <AttachFile fontSize='small' sx={{ marginTop: '-10px' }} />
                </TableBadge>
              </Tooltip></div>
          </>
        );
      }
    },
  ];

  let isReopenDisabled = cookies.get('role') === 'Supervisor' || 
    cookies.get('role') === 'Manager' || 
    cookies.get('role') === 'System Admin' ? false : true;

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <StyledCard>
            <FlexDiv><StyledCardTitle>Service Logs</StyledCardTitle></FlexDiv>
            <Box>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={3} lg={2} xl={2}>
                  <CustomInputLabel id='airline-label' aria-label='Select-item'>Airline</CustomInputLabel>
                  <FormControl variant='standard' fullWidth>
                    <CustomSelect
                      {...SelectInputProps}
                      id='airline'
                      labelId='airline-label'
                      onChange={onChangeSearch}
                      name='airline'
                      value={!search.airline ? 'placeholder' : search?.airline}
                      disabled={airlineId ? true : false}
                    >
                      <MenuItem value={false} disabled>Select an Airline</MenuItem>
                      {airlines.map((airline, index) => (
                        <MenuItem key={index} value={airline.id}>{airline.code}</MenuItem>
                      ))}
                    </CustomSelect>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={3} lg={2} xl={2}>
                  <CustomInputLabel id='contract-label' aria-label='Select-contract'>Department</CustomInputLabel>
                  <FormControl variant='standard' fullWidth>
                    <CustomSelect
                      {...SelectInputProps}
                      id='contract'
                      labelId='contract-label'
                      fullWidth
                      className={`${styles.brInput}`}
                      onChange={handleContractType}
                      value={props.contract_Type}
                    >
                      <MenuItem value='placeholder' disabled>Select a Department</MenuItem>
                      {cookies.get('contract_types')?.map((type, index) => (
                        <MenuItem key={index} value={type}>{type}</MenuItem>
                      ))}
                    </CustomSelect>
                  </FormControl>
                </Grid>
                <Grid item>
                  <CustomInputLabel id='bill_from_details' className={`${styles.radioLabel} ${styles.px3}`}>Daily / Monthly Service Log</CustomInputLabel>
                  <RadioGroup aria-labelledby='user-status' name='type' value={search.type} onChange={onChangeSearch} row className={`${styles.ml0} ${styles.mb2} ${styles.px3}`}>
                    <Stack direction='row' spacing={3} className={`${styles.fMiddle}`} flexWrap='wrap' sx={{ marginLeft: '-10px' }}>
                      <CustomRadio control={<Radio size='small' />} value='DAY' label='Daily Service Log' />
                      <CustomRadio control={<Radio size='small' />} value='MONTH' label='Monthly Service Log' />
                    </Stack>
                  </RadioGroup>
                </Grid>
                {search.type && search.type === 'DAY' ?
                  <>
                    <Grid item xs={12} sm={6} md={3} lg={2} xl={2}>
                      <CustomInputLabel htmlFor='date'> From Date</CustomInputLabel>
                      <CustomDatePicker
                        slotProps={{
                          textField: {
                            ...InputProps,
                            placeholder: 'Date',
                            fullWidth: true
                          },
                        }}
                        variant='standard'
                        disableUnderline
                        value={dayjs(search.start_date)}
                        onChange={(date) => onChangeSearch({
                          target: {
                            name: 'start_date',
                            value: date.format('YYYY-MM-DD')
                          }
                        })}
                        format='DD MMM YY'
                        name='day'
                        className={`${styles.w100}`}
                        disabled={airlineId ? true : false}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} lg={2} xl={2}>
                      <CustomInputLabel htmlFor='date'> To Date</CustomInputLabel>
                      <CustomDatePicker
                        slotProps={{
                          textField: {
                            ...InputProps,
                            placeholder: 'Date',
                            fullWidth: true
                          },
                        }}
                        variant='standard'
                        disableUnderline
                        value={dayjs(search.end_date)}
                        minDate={dayjs(search.start_date)}
                        maxDate={dayjs(search.start_date).endOf('month')}
                        onChange={(date) => onChangeSearch({
                          target: {
                            name: 'end_date',
                            value: date.format('YYYY-MM-DD')
                          }
                        })}
                        format='DD MMM YY'
                        name='day'
                        className={`${styles.w100}`}
                        disabled={airlineId ? true : false}
                      />
                    </Grid>
                  </>
                  :
                  <Grid item xs={2}>
                    <CustomInputLabel htmlFor='date'>Month</CustomInputLabel>
                    <CustomDatePicker
                      slotProps={{
                        textField: {
                          ...InputProps,
                          placeholder: 'Month',
                          fullWidth: true
                        },
                      }}
                      views={['month', 'year']}
                      variant='standard'
                      disableUnderline
                      format={MonthFormat}
                      value={dayjs(search.month)}
                      onChange={(date) => onChangeSearch({
                        target: {
                          name: 'month',
                          value: date.endOf('month').format('YYYY-MM-DD')
                        }
                      })}
                      name='month'
                      className={`${styles.w100}`}
                      disabled={airlineId ? true : false}
                    />
                  </Grid>
                }
              </Grid>
            </Box>
          </StyledCard>
        </Grid>

        <Grid item xs={12}>
          <StyledCard className={styles.h100}>
            <FlexDiv><StyledCardTitle>{search.type && search.type === 'DAY' ? 'Daily Service Logs' : 'Monthly Service Log'}</StyledCardTitle></FlexDiv>
            <Stack direction='row' spacing={2} justifyContent='flex-end'
              flexWrap={{
                xs: 'wrap',
                sm: 'nowrap'
              }}
              alignItems={'center'} mb={2} mt={'-32px'}
            >
              <FormLabel component='small' className={`${styles.xsW100} ${styles.pr2}`}><small>Filter:</small> </FormLabel>
              <RadioGroup aria-labelledby='log-filter' name='type'
                value={filterLogs}
                onChange={onChangeFilter}
                row className={styles.ml0}
                defaultValue={'All'}>
                <Stack direction='row' spacing={2} className={`${styles.fMiddle}`} flexWrap='wrap'>
                  <CustomRadio control={<Radio size='small' />} value='All' label='All' />
                  <CustomRadio control={<Radio size='small' />} value='Pending' label='Pending' />
                  <CustomRadio control={<Radio size='small' />} value='Submitted' label='Submitted' />
                  <CustomRadio control={<Radio size='small' />} value='Finalized' label='Finalized' />
                </Stack>
              </RadioGroup>

            </Stack>

            <Grid container spacing={4}>
              <Grid item xs={12}>
                <div className={styles.tableWrapper}>
                  <Box className={`${styles.tableOuter} ${logStyle.logTableOuter}`}>
                    <StyledDataGrid
                      {...DataGridProps}
                      rows={filteredRows}
                      columns={logCol}
                      disableRowSelectionOnClick
                      className={`${logStyle.logTable}`}
                      param={filteredRows.length}
                    // sx={{ width: 'fit-content' }}
                    // getRowClassName={(params) => params.row.finalized ? 'finalized-row' : ''}
                    />
                  </Box>
                </div>
              </Grid>
              <DocModalContainer />
            </Grid>
          </StyledCard>
        </Grid>
        <Grid item container justifyContent={'space-between'} spacing={3}>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6} order={{
            xs: 2,
            xl: 1
          }}>
            <div ref={refROBrn} className={styles.fColumn}>
              <CustomButton variant='contained' className={`${styles.minWidth280} ${styles.alignSelfStart}`} name='reopen'
                disabled={checkedRows.length === 0 || filterLogs === 'All' || filterLogs === 'Pending' || filterLogs === 'Submitted' || isReopenDisabled}
                onClick={(e) => props.handleOpenPopup('review', e.currentTarget)}
              > Reopen Logs (Supervisors Only)</CustomButton>
            </div>
          </Grid>

          <Grid item xs={12} xl={4} order={{
            xs: 1,
            xl: 2
          }}>
            <CustomTextField
              variant='outlined'
              id=''
              fullWidth
              placeholder='Enter remarks (Optional)'
              type='remark'
              inputProps={{ 'aria-label': 'remarks' }}
              value={remark}
              name='remark'
              onChange={onChange}
              className={styles.borderedIpTextfield}
              InputProps={{
                classes: {
                  root: styles.borderedIpRoot,
                  input: styles.borderedIp,
                  notchedOutline: styles.notchedOutline,
                  error: styles.errorInput,
                },
              }}
            />
          </Grid>

          {/* <Grid item xs={12} sm={6} md={6} lg={6} xl={2} order={{ xs: 3 }}>
            {checkedRows.length > 0 && (
              (() => {
                // Check if at least one checked row is 'Submitted' for all auto values
                const hasSubmitted = filteredRows
                  .filter(row => checkedRows.includes(row.id))
                  .every(row =>
                    row.status === 'Submitted' &&
                  row.data.every(item => item?.name?.includes(' | Auto'))
                  );
                console.log(hasSubmitted, 'hasSubmitted');
                return (
                  <CustomButton
                    variant='contained'
                    className={`${styles.mlauto} ${styles.dFlex} ${reportStyles.finalizeBtn}`}
                    name='submit'
                    onClick={() => onSubmitLogs(hasSubmitted ? 'Finalized' : undefined)}
                    disabled={checkedRows.length === 0 || filterLogs === 'Finalized'}
                  >
                    {hasSubmitted ? 'Submit' : 'Submit'}
                  </CustomButton>
                );
              })()
            )}
            
          </Grid> */}
          <Grid item xs={12} sm={6} md={6} lg={6} xl={2} order={{ xs: 3 }}>

            <CustomButton
              variant='contained'
              className={`${styles.mlauto} ${styles.dFlex} ${reportStyles.finalizeBtn}`}
              name='submit'
              onClick={() => onSubmitLogs()}
              disabled={checkedRows.length === 0 || filterLogs === 'Finalized'}
            >
                   Submit
            </CustomButton>
          </Grid>
        </Grid>
      </Grid>

      <Popover
        open={props.popup === 'Finalized'}
        onClose={props.handleClosePopup}
        anchorReference='anchorPosition'
        anchorPosition={{
          top: window.innerHeight / 2,
          left: window.innerWidth / 2,
        }}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'center',
        }}
        style={{ zIndex: 4 }}
      ><div className={styles.p4}>
          <Typography variant='h6' pb={1}>Confirm Action</Typography>
          <Divider direction='horizontal' className={`${styles.w100}`} />
          <Typography variant='body2' pt={3}>Service Logs data will now be processed for billing and invoicing.</Typography>
          {
            // list all selected logs from filteredData whose ids are present in finalizeLogs
            filteredRows?.filter((log) => log.status !== 'Finalized' && checkedRows?.includes(log.id)).sort((a, b) => new Date(a.date) - new Date(b.date)).map((log, index) => (
              <Typography variant='body2' key={index}>• {log.type === 'MONTH' ? moment(log.date).format('MMMM').toUpperCase() : moment(log.date).format(DateFormat).toUpperCase()}</Typography>
            ))
          }
          <Stack pt={'2rem'} spacing={1} direction='row' justifyContent={'space-between'}>
            <CustomButton variant='contained' size='small' onClick={() => { handleClosePopup(); onSubmitLogs('Finalized'); }} > <Typography variant='body2' lineHeight='normal' fontWeight='bold'>Okay</Typography></CustomButton>
            <CustomButton variant='outlined' size='small' onClick={() => handleClosePopup()}> <Typography variant='body2' lineHeight='normal'>Cancel</Typography></CustomButton>
          </Stack>
        </div>
      </Popover>

      <Popover
        open={props.popup === 'Submitted'}
        onClose={props.handleClosePopup}
        anchorReference='anchorPosition'
        anchorPosition={{
          top: window.innerHeight / 2,
          left: window.innerWidth / 2,
        }}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'center',
        }}
        style={{ zIndex: 4 }}
      ><div className={styles.p4}>
          <Typography variant='h6' pb={1}>Confirm Action</Typography>
          <Divider direction='horizontal' className={`${styles.w100}`} />
          <Typography variant='body2' pt={3}>Empty field found. The data will not be finalized. Would you like to continue with the action?</Typography>
          {
            // list all selected logs from filteredData whose ids are present in finalizeLogs
            filteredRows?.filter((log) => log.data.some(field => field.value === '' || field.value === null) && checkedRows?.includes(log.id))
              .sort((a, b) => new Date(a.date) - new Date(b.date)).map((log, index) => (
                <Typography variant='body2' key={index}>• {log.type === 'MONTH' ? moment(log.date).format('MMMM').toUpperCase() : moment(log.date).format(DateFormat).toUpperCase()}</Typography>
              ))
          }
          <Stack pt={'2rem'} spacing={1} direction='row' justifyContent={'space-between'}>
            <CustomButton variant='contained' size='small' onClick={() => { handleClosePopup(); onSubmitLogs('Submitted'); }} > <Typography variant='body2' lineHeight='normal' fontWeight='bold'>Okay</Typography></CustomButton>
            <CustomButton variant='outlined' size='small' onClick={() => handleClosePopup()}> <Typography variant='body2' lineHeight='normal'>Cancel</Typography></CustomButton>
          </Stack>
        </div>
      </Popover>

      {(props.popup === 'notes') &&
        <AddNotes popup={props.popup}
          anchorEl={props.anchorEl}
          closePopup={props.handleClosePopup}
          noteFields={props.noteFields}
          handleNotes={props.handleNotes}
          addNote={props.addNote}
          notes={props.popupData.filteredNotes || []}
          handleReadMore={props.handleReadMore}
          showMoreNote={props.showMoreNote}
          isRemarks={props.isRemarks}
        />}

      {props.popup === 'review' &&
        <ReOpenModal
          anchorEl={props.anchorEl}
          submitFunc={() => props.onSubmitLogs('Reopen')}
          remark={props.remarks}
          setRemark={props.setRemark}
          modalflight={props.filteredReportLogs}
          handleClose={props.handleClosePopup}
        />
      }
      <ConfirmModalContainer />
    </>
  );
};

export default Logs;
